<button
  (click)="onGoBack()"
  class="flex items-center gap-2 text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
  aria-label="Volver a la página principal"
  title="Volver"
>
  <svg
    class="w-7 h-7 text-red-600"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M15 19l-7-7 7-7"
    ></path>
  </svg>
  <span class="text-base font-extralight fs-condensed">VOLVER</span>
</button>
